<template>
    <div class="search-eki">
        <p class="title-box-search">
            路線名または駅名を入力してください。
        </p>
        <a class="button-hide-show" id="button-hide-box-search" @click="handleHideForm" v-show="isHideTable" >
            -
        </a>
        <a class="button-hide-show" id="button-show-box-search" style="display:none" @click="handleShowForm" v-show="isShowTable">
            +
        </a>
        <el-form ref="ruleForm" class="form box-search" id="box-search" v-show="isForm" @keyup.enter.native="submitForm()">
            <el-form-item label="" prop="type" class="option-search">
                <el-radio-group v-model="radio">
                    <el-radio label="1">一次相続：配偶者がご存命の方（ご夫婦どちらかが初めて亡くなる場合）</el-radio>
                    <el-radio label="2">二次相続：配偶者が既にお亡くなりになっている方（未婚の方・離婚されている方はこちらを選択してください）</el-radio>
                </el-radio-group>
            </el-form-item>
            <div class="input-search">
                <el-form-item prop="route" class="txtSearch1">
                    <label>路線名</label>
                    <div class="input-icons">
                        <i class="fa fa-search icon"></i>
                        <el-input v-model="inputRoute"  placeholder="例）中央線" class="input-field"></el-input>
                    </div>
                </el-form-item>
                <el-form-item prop="station" class="txtSearch2">
                    <label>駅名</label>
                    <div class="input-icons">
                        <i class="fa fa-search icon"></i>
                        <el-input v-model="inputStation"  placeholder="例）東京" class="input-field"></el-input>
                    </div>
                </el-form-item>
            </div>
            <el-form-item class="button-search">
                <el-button class="gtm_rosenka_search" :plain="true" :loading="loading" @click="submitForm()"><span class="gtm_rosenka_search">検索</span></el-button>
            </el-form-item>
        </el-form>
        <!--alert-->
        <el-alert v-show="alertSearch" title="駅名又は駅名の一部を入力してください。" type="warning" show-icon :closable="false"> </el-alert>
        <!--End alert-->
    </div>
</template>
<script>
import stationTax from '@/api/stationtax/station-tax-cl.js'
export default {
  data () {
    return {
      inputRoute: '',
      inputStation: '',
      radio: '1',
      isForm: true,
      isHideTable: true,
      isShowTable: false,
      loading: false,
      dataTax: [],
      alertSearch: false
    }
  },
  methods: {
    submitForm () {
      if (this.inputRoute === '' && this.inputStation === '') {
          this.warning()
          this.$emit('dataTax', null)
      } else {
          this.success()
          this.searchDataTax(this.radio, this.inputRoute, this.inputStation)
          this.$emit('clearCurrentRow', null)
      }
    },
    handleHideForm () {
      this.isForm = false
      this.isHideTable = false
      this.isShowTable = true
    },
    handleShowForm () {
      this.isForm = true
      this.isHideTable = true
      this.isShowTable = false
    },
    searchDataTax (radioParam, inputRoute, inputStation) {
      let _this = this
      this.loading = true
      stationTax.findDataTax(radioParam, inputRoute, inputStation).then(response => {
        _this.dataTax = []
        response.data.data.forEach(function (item, index) {
          _this.dataTax.push({ 'id': item.id, 'stationName': item.stationName, 'routeName': item.routeName, 'passengerNumber': item.passengerNumber, 'address': item.address, 'routePrice': item.routePrice })
        })
        this.loading = false
        this.$emit('dataTax', _this.dataTax)
      })
    },
    warning () {
      this.alertSearch = true
    },
    success () {
      this.alertSearch = false
    }
  },
  created () {
  }
}
</script>
